import React, { useState } from 'react';
import { Modal, Button, Form, Table } from 'react-bootstrap';
import { FaArrowUp } from 'react-icons/fa';
import MappingsPrintModal from './mappings-print';
import PropTypes from 'prop-types';

const ReleaseList = ({ data, onView, onReceiveItem, isShipmentClosed = false, poNumber = '', partNumber = '', receivingShipmentId = '', supplierName = '' }) => {
  const [showPrintModal, setShowPrintModal] = useState(false);
  const [printModalRelease, setPrintModalRelease] = useState(null);

  const handlePrintLabelsClick = (release) => {
    setPrintModalRelease(release);
    setShowPrintModal(true);
  };

  const handlePrintModalClose = () => {
    setShowPrintModal(false);
    setPrintModalRelease(null);
  };

  const handlePrintModalSubmit = (formData) => {
    // For now, just close the modal
    setShowPrintModal(false);
    setPrintModalRelease(null);
    // You can use formData for API integration later
  };

  return (
    <div className="list-group">
      {data.length === 0 ? (
        <div className="list-group-item text-muted">No releases found.</div>
      ) : (
        data.map((release) => {
          const receivedInThisShipment = Number(release.receivedInThisShipment);
          const requestedQty = Number(release.requestedQuantity) || 0;
          const receivedQty = Number(release.receivedQuantity) || 0;
          const isVoided = release.isVoided || false;
          const isFullyReceived = requestedQty > 0 && receivedQty >= requestedQty;
          const isPartiallyReceived = receivedInThisShipment > 0 && !isFullyReceived;
          const releaseLabel = release.poItemReleaseID
            ? `Release #${release.poItemReleaseID}`
            : 'Release';
          
          return (
            <div key={release.poItemReleaseID} className="list-group-item d-flex justify-content-between align-items-center">
              <span>{releaseLabel}</span>
              <span style={{ fontWeight: 500 }}>{release.requestDate}</span>
              <div className="d-flex align-items-center">
                {isVoided ? (
                  <span className="badge bg-danger me-2">Voided: {receivedInThisShipment}</span>
                ) : isFullyReceived ? (
                  <>
                    <span className="badge bg-success me-2" style={{ backgroundColor: '#28a745', color: '#fff' }}>
                      <i className="fa fa-check-circle me-1"></i>
                      Fully Received
                    </span>
                    {receivedInThisShipment > 0 && (
                    <button
                      className="btn btn-sm btn-outline-warning ms-2"
                      onClick={() => handlePrintLabelsClick(release)}
                      title="Print labels for this release"
                    >
                      Print Labels
                    </button>
                    )}
                  </>
                ) : isPartiallyReceived && !isShipmentClosed ? (
                  <>
                    <span className="badge bg-warning me-2" style={{ backgroundColor: '#ffc107', color: '#212529' }}>
                      <i className="fa fa-clock me-1"></i>
                      Partially Received: {receivedInThisShipment}
                    </span>
                    <button
                      className="btn btn-sm btn-outline-warning ms-2"
                      onClick={() => handlePrintLabelsClick(release)}
                      title="Print labels for this release"
                    >
                      Print Labels
                    </button>
                  </>
                ) : receivedInThisShipment !== 0 && !isNaN(receivedInThisShipment) ? (
                  <span className="badge bg-info me-2" style={{ backgroundColor: '#17a2b8', color: '#fff' }}>
                    Received: {receivedInThisShipment}
                  </span>
                ) : null}
                
                {/* Show up arrow - always enabled for non-voided items */}
                {!isVoided && (
                  <span
                    className="ms-2"
                    style={{ 
                      cursor: 'pointer', 
                      color: '#28a745', 
                      fontSize: 16
                    }}
                    title={receivedInThisShipment > 0 ? 
                      "View received item" : 
                      (requestedQty > receivedQty ? "Mark as Received" : "View release details")
                    }
                    onClick={(e) => {
                      e.stopPropagation();
                      if (onView) {
                        onView(release);
                      }
                    }}
                  >
                    <FaArrowUp />
                  </span>
                )}
              </div>
            </div>
          );
        })
      )}
      <MappingsPrintModal
        show={showPrintModal}
        onClose={handlePrintModalClose}
        onSubmit={handlePrintModalSubmit}
        poNumber={printModalRelease?.poNumber || poNumber}
        partNumber={printModalRelease?.itemName || partNumber}
        quantity={printModalRelease?.receivedInThisShipment || ''}
        receivingShipmentId={receivingShipmentId}
        poReceivingId={printModalRelease?.poReceivingId?.toString() || ''}
        partId={printModalRelease?.partId ?? null}
        poItemDetailId={printModalRelease?.poItemDetailID?.toString() || ''}
        releaseIdExt={printModalRelease?.poItemReleaseID?.toString() || ''}
        supplierName={
          printModalRelease?.vendorName ||
          printModalRelease?.supplierName ||
          printModalRelease?.supName ||
          supplierName ||
          ''
        }
        userId={localStorage.getItem('UserId') || ''}
        initialPrinter=""
        initialNumberOfLabels="1"
      />
    </div>
  );
};

ReleaseList.propTypes = {
  data: PropTypes.array.isRequired,
  onView: PropTypes.func,
  onReceiveItem: PropTypes.func,
  isShipmentClosed: PropTypes.bool,
  poNumber: PropTypes.string,
  partNumber: PropTypes.string,
  receivingShipmentId: PropTypes.string,
  supplierName: PropTypes.string,
};

export default ReleaseList;
